import { render, staticRenderFns } from "./MAPayment.vue?vue&type=template&id=4393fa10&scoped=true&"
import script from "./MAPayment.vue?vue&type=script&lang=js&"
export * from "./MAPayment.vue?vue&type=script&lang=js&"
import style0 from "./MAPayment.vue?vue&type=style&index=0&id=4393fa10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4393fa10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
